export default class Tabs {
	constructor(config) {
		this.el = config.el || document.querySelectorAll(".tabs");
		this.triggers = this.el.querySelectorAll(".tabs__trigger");
		this.triggersDesktop = this.el.querySelectorAll(
			".tabs__trigger-desktop"
		);
		this.tabNavigation = this.el.querySelector(".tab__navigation");
		this.panels = this.el.querySelectorAll(".tabs__panel");
		this.links = this.el.querySelectorAll(".tabs_link");
		this.items = this.el.querySelectorAll(".tabs__item");
		this.visibleClassSmall = "tabs--panel-visible";
		this.isTabsHidden = this.triggers.length > 0;
		this.tabsTriggerActiveIndicator = this.el.querySelector(
			".tabs__trigger-active-indicator"
		);
		utilities.dataStorage.put(this.el, "component", this);
		this.init();
	}
	init() {
		const self = this;
		self.checkHash();
		this.attachEvents();
	}
	checkHash() {
		let hash = window.location.hash;
		const self = this;
		if (hash) {
			hash = decodeURI(hash);
			const elementMatch = this.el.querySelector(hash);
			if (elementMatch) {
				var item = this.el.querySelector(
					elementMatch.getAttribute("data-targetid")
				);
				this.showItem(item, true);

				if (
					document.readyState == "interactive" ||
					document.readyState == "loading"
				) {
					window.addEventListener("load", event => {
						self.scrollToTabs();
					});
				} else {
					self.scrollToTabs();
				}
			} else {
				this.showItem(this.items[0], true);
			}
		} else {
			if (
				utilities.getSize() != "xsmall" &&
				utilities.getSize() != "small"
			) {
				this.showSlide(this.items[0], true);
			} else {
				this.showItem(this.items[0]);
			}
		}
	}
	scrollToTabs() {
		var offset =
			this.el.getBoundingClientRect().top -
			document.body.getBoundingClientRect().top;
		setTimeout(() => {
			window.scrollTo(0, offset - 300);
		}, 100);
	}
	showItem(element, updateHash) {
		if (utilities.getSize() != "xsmall" && utilities.getSize() != "small") {
			this.showSlide(element, updateHash);
		} else {
			this.showPanel(element, updateHash);
		}
	}
	attachEvents() {
		const self = this;
		utilities.emitter.on("responsive/resize", size => {
			if (size !== "xsmall" && size !== "small") {
				const currentItem = this.el.querySelector(
					".tabs--panel-visible"
				);
				if (currentItem) {
					this.updateHeight(currentItem);
				}
			}
		});
		utilities.emitter.on("responsive/sizechange", size => {
			const currentItem = this.el.querySelector(".tabs--panel-visible");
			if (size !== "xsmall" && size !== "small") {
				this.showSlide(currentItem);
			} else {
				this.showPanel(currentItem);
				this.resetHeight();
			}
		});
		this.triggers.forEach(el => {
			el.addEventListener("click", e => {
				if (
					utilities.getSize() == "xsmall" ||
					utilities.getSize() == "small"
				) {
					self.toggleTabItem(e);
				} else {
					if (
						!el.parentElement.classList.contains(
							"tabs--panel-visible"
						)
					) {
						self.showSlide(e.currentTarget.parentElement);
					}
				}
			});
		});
		this.triggersDesktop.forEach(el => {
			el.addEventListener("click", e => {
				if (
					!el.parentElement.classList.contains(
						"tabs__trigger-desktop--active"
					)
				) {
					self.showSlide(
						this.el.querySelector(e.currentTarget.dataset.targetid)
					);
				}
			});
		});
		if (this.tabNavigation) {
			this.tabNavigation.addEventListener("keydown", e => {
				this.onKeyboardNavigation(e);
			});
		}
	}
	onKeyboardNavigation(e) {
		var tabFocus = null;
		if (e.keyCode === 36 || e.keyCode === 35) {
			e.preventDefault();
			// home
			if (e.keyCode === 36) {
				tabFocus = 0;
			} // end
			if (e.keyCode === 35) {
				tabFocus = this.triggersDesktop.length - 1;
			}
		}
		if (e.keyCode === 39 || e.keyCode === 37) {
			const currentTriggerDesktop = this.el.querySelector(
				".tabs__trigger-desktop--active"
			);
			tabFocus = Array.prototype.indexOf.call(
				currentTriggerDesktop.parentElement.children,
				currentTriggerDesktop
			);

			// this.triggersDesktop[tabFocus].setAttribute("tabindex", -1);
			if (e.keyCode === 39) {
				tabFocus++;
				// If we're at the end, go to the start
				if (tabFocus >= this.triggersDesktop.length) {
					tabFocus = 0;
				}
				// Move left
			} else if (e.keyCode === 37) {
				tabFocus--;
				// If we're at the start, move to the end
				if (tabFocus < 0) {
					tabFocus = this.triggersDesktop.length - 1;
				}
			}
		}
		if (tabFocus != null) {
			this.triggersDesktop[tabFocus].setAttribute("tabindex", 0);
			this.triggersDesktop[tabFocus].focus();
			this.showItem(
				this.el.querySelector(
					this.triggersDesktop[tabFocus].dataset.targetid
				)
			);
		}
	}
	toggleTabItem(e) {
		const trigger = e.currentTarget;
		const tabItem = trigger.parentElement;
		if (tabItem.classList.contains(this.visibleClassSmall)) {
			this.hidePanel(tabItem);
		} else {
			this.showPanel(tabItem);
		}
	}
	hidePanel(tabItem) {
		utilities.resetHashUrl();
		var trigger = tabItem.querySelector(".tabs__trigger");
		tabItem.classList.remove(this.visibleClassSmall);
		if (trigger && this.items.length > 1) {
			utilities.setAriaProp(trigger, "selected", false);
		}
		let panel = tabItem.querySelector(".tabs__panel");
		panel.style.visibility = "hidden";
		if (utilities.getSize() == "xsmall" || utilities.getSize() == "small") {
			if (this.items.length > 1)
				utilities.setAriaProp(panel, "hidden", true);
			panel.style.height = "0px";
		}
	}
	showPanel(tabItem, preventSetHash) {
		// hide all others first
		this.hideAllPanels();
		tabItem.classList.add(this.visibleClassSmall);
		var trigger = tabItem.querySelector(".tabs__trigger");
		//console.log("safglæ", this.items);
		if (trigger && this.items.length > 1) {
			utilities.setAriaProp(trigger, "selected", true);
		}
		let panel = tabItem.querySelector(".tabs__panel");
		if (this.items.length > 1)
			utilities.setAriaProp(panel, "hidden", false);
		panel.style.visibility = "visible";

		// set height
		panel.style.height = panel.scrollHeight + "px";
		if (!preventSetHash) {
			//set the url corresponding to id so we can deeplink
			utilities.setHashUrl(tabItem.getAttribute("data-triggerid"));
		}
	}
	hideAllPanels() {
		this.panels.forEach(panel => {
			this.hidePanel(panel.parentElement);
		});
	}
	showSlide(item, preventSetHash) {
		if (item == null) {
			item = this.el.querySelector(".tabs__item");
		}
		//reset height from mobile state.
		if (item.querySelector(".tabs__panel")) {
			item.querySelector(".tabs__panel").style.height = "";
		}

		//get current Item and update classes and tabindex
		const currentItem = this.el.querySelector(".tabs--panel-visible");
		if (currentItem) {
			currentItem.classList.add("tabs--panel-invisible");
			currentItem.classList.remove("tabs--panel-visible");
			var panel = currentItem.querySelector(".tabs__panel");
			utilities.setAriaProp(panel, "hidden", true);
			panel.style.visibility = "hidden";
			if (this.items.length > 1) {
				utilities.setAriaProp(currentItem, "hidden", true);
				utilities.setAriaProp(currentItem, "selected", false);
			}
			currentItem.querySelectorAll(".tabs_link").forEach(element => {
				element.tabIndex = -1;
			});
		}
		if (this.items.length > 1) {
			utilities.setAriaProp(item, "hidden", false);
			utilities.setAriaProp(item, "selected", true);
		}
		item.classList.remove("tabs--panel-invisible");
		item.classList.add("tabs--panel-visible");
		var panel = item.querySelector(".tabs__panel");
		utilities.setAriaProp(panel, "hidden", false);
		panel.style.visibility = "visible";

		this.el.querySelectorAll(".tabs_link").forEach(e => {
			e.tabIndex = -1;
		});
		item.querySelectorAll(".tabs_link").forEach(element => {
			element.tabIndex = 0;
		});
		var $this = this;
		this.el.querySelectorAll(".tabs__trigger-desktop").forEach(e => {
			e.tabIndex = -1;
			if ($this.items.length > 1) {
				utilities.setAriaProp(e, "selected", "false");
			}
		});
		//remove current desktoptriggers activeclass ;
		this.el
			.querySelectorAll(".tabs__trigger-desktop--active")
			.forEach(e => {
				e.classList.remove("tabs__trigger-desktop--active");
			});
		// update desktoptrigger with activeclass as well.
		let activeDesktopTrigger = this.el.querySelector(
			"#" + item.getAttribute("data-triggerid")
		);
		if (activeDesktopTrigger) {
			activeDesktopTrigger.tabIndex = 0;
			activeDesktopTrigger.classList.add("tabs__trigger-desktop--active");
			if (this.items.length > 1) {
				utilities.setAriaProp(activeDesktopTrigger, "selected", "true");
			}
		}

		this.updateHeight(item);
		if (!preventSetHash) {
			//set the url corresponding to id so we can deeplink
			utilities.setHashUrl(item.getAttribute("data-triggerid"));
		}
	}
	hideSlide(item) {
		utilities.resetHashUrl();
		item.classList.remove("tabs--panel-visible");
		item.classList.add("tabs--panel-invisible");
	}
	hideAllSlides() {
		this.items.forEach(item => {
			item.classList.remove("tabs--panel-visible");
			item.classList.remove("tabs--panel-invisible");
		});
	}
	resetHeight() {
		this.el.style.height = "";
	}
	updateHeight(currentItem) {
		let tallestTrigger = 0;
		this.triggersDesktop.forEach(item => {
			if (item.scrollHeight > tallestTrigger) {
				tallestTrigger = item.scrollHeight;
			}
		});

		var tabsPanelItem = currentItem.querySelector(".tabs__panel");
		if (tabsPanelItem) {
			let currentPanelHeight = tabsPanelItem.scrollHeight;
			this.el.style.height = tallestTrigger + currentPanelHeight + "px";
		}
	}
}
